import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

/**
 * Lightweight guard for /request-pdf — only verifies a session exists, then the component
 * streams the PDF immediately (no app layout or module menu check).
 */
@Injectable({
  providedIn: 'root'
})
export class SecurePdfAuthGuard {

  constructor(private readonly router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const userData = localStorage.getItem('currentUserData');
    const parsed = userData ? JSON.parse(userData) : null;
    if (parsed?.accessToken) {
      return true;
    }
    return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }
}
